import styled from '@emotion/styled';

export const ReportsLayoutContainer = styled.div`
  padding: 1rem;
  box-sizing: border-box;
  width: 100%;
`;

export const ReportsLayoutHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ReportsLayoutTitle = styled.h1`
  font-size: 2rem;
  font-weight: 600;
`;

export const ReportsLayoutButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;
